$(document).ready(function () {
    $(".down_button").click(function () {
        var link = "#" + $(this).attr("data-link");
        $('html, body').animate({
            scrollTop: $(link).offset().top - 77
        }, 1500);
    });

    if ($('#pinContainer').length > 0) {
        var controller = new ScrollMagic.Controller();

        var duration = 150;

        var wipeAnimation = new TimelineMax()
            .add([
                TweenMax.to("section.panel.blue #first_img", duration * 2, {autoAlpha: 1}),
                TweenMax.to("section.panel.blue #first_vertical_title", duration * 2, {autoAlpha: 1}),
            ])
            .add([
                TweenMax.to("section.panel.blue #first_vertical_title", duration, {autoAlpha: 1}),
                TweenMax.fromTo("section.panel.blue #first_block_parallx", duration, {x: "-100%"}, {
                    x: "50%",
                    ease: Linear.easeNone
                })
            ])
            .add([
                TweenMax.to("section.panel.blue #first_block_parallx", duration, {autoAlpha: 1})
            ])
            .add([
                TweenMax.to("section.panel.blue #first_img", duration, {autoAlpha: 0}),
                TweenMax.to("section.panel.blue #first_block_parallx", duration, {autoAlpha: 0}),
            ])
            .add([
                TweenMax.to("section.panel.blue #second_img", duration * 2, {autoAlpha: 1}),
                TweenMax.to("section.panel.blue #second_vertical_title", duration * 2, {autoAlpha: 1}),
            ])
            .add([
                TweenMax.fromTo("section.panel.blue #second_block_parallx", duration, {x: "100%"}, {
                    x: "60%",
                    ease: Linear.easeNone
                })
            ])
            .add([
                TweenMax.to("section.panel.blue #second_img", duration, {autoAlpha: 1}),
                TweenMax.to("section.panel.blue #second_block_parallx", duration, {autoAlpha: 1})
            ])
            .add([
                TweenMax.to("section.panel.blue #second_img", duration, {autoAlpha: 0}),
                TweenMax.to("section.panel.blue #second_block_parallx", duration, {autoAlpha: 0}),
            ])
            .add([
                TweenMax.to("section.panel.blue #third_img", duration, {autoAlpha: 1}),
                TweenMax.to("section.panel.blue #third_vertical_title", duration, {autoAlpha: 1}),
            ])
            .add([
                TweenMax.fromTo("section.panel.blue #third_block_parallx", duration, {x: "-100%"}, {
                    x: "30%",
                    ease: Linear.easeNone
                })
            ])
            .add([
                TweenMax.to("section.panel.blue #third_img", duration, {autoAlpha: 1}),
                TweenMax.to("section.panel.blue #third_block_parallx", duration, {autoAlpha: 1})
            ])
            .add([
                TweenMax.to("section.panel.blue #third_img", duration, {autoAlpha: 1}),
                TweenMax.to("section.panel.blue #third_block_parallx", duration, {autoAlpha: 1})
            ]);


        new ScrollMagic.Scene({
            triggerElement: "#pinContainer",
            triggerHook: "onLeave",
            duration: "10000"
        })
            .setPin("#pinContainer")
            .setTween(wipeAnimation)
            .addTo(controller);
    }


});




// WEBPACK FOOTER //
// ./js/editweb.js